import React from "react";
import {Modal, Tab, Tabs} from "react-bootstrap";
import {Link} from "react-router-dom";
import Moment from "react-moment";
import {NumericFormat as NumberFormat} from "react-number-format";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MiTabla from "../../../_helpers/MiTabla";
import {prepareDataSearch} from "../../../_helpers";
import {traerPalabrasTabla} from "../../../_actions";
import {ventasService} from "../../../_services";
import authService from "../../../_services/cart/authService";
import alertService from "../../../_services/cart/alert.service";
import {VentaDP} from "../../vendedor/ventas/utils/ventasUtils";

const tableRefCompras = React.createRef();
const tableRefVentas = React.createRef();

/**
 * Todas las operaciones de una persona, de los dos lados del mostrador.
 *
 * <p>Es el "ver todas" del resumen del detalle de usuario. Pagina contra el mismo buscador que la
 * pantalla de ventas del admin ({@code /api/admin/ventas/buscar}) filtrando por `compradorId` o
 * `vendedorId`, asi que trae la misma fila y el mismo panel de detalle que el admin ya conoce en
 * vez de una tabla nueva que se parezca.
 *
 * <p>`tabInicial` decide con cual solapa abre, porque el boton que lo abre siempre esta al lado de
 * una de las dos tarjetas: llegar a "Ventas" y ver "Compras" seria un click de castigo.
 */
class VentasUsuarioModal extends React.Component {

    state = {
        tipoKey: this.props.tabInicial === "VENTAS" ? "VENTAS" : "COMPRAS"
    };

    buscarData = (query, comoVendedor) => {
        const {usuario} = this.props;

        return new Promise((resolve) => {
            const filtro = comoVendedor ? {vendedorId: usuario.id} : {compradorId: usuario.id};

            ventasService
                .buscarVentasTodas(prepareDataSearch(query, "createdDate", "DESC", filtro))
                .then(
                    (data) => {
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0
                        });
                    },
                    (error) => {
                        alertService.error(error);
                        resolve({data: [], page: 0, totalCount: 0});
                    }
                );
        });
    };

    /**
     * La columna que cambia entre las dos solapas: en las compras interesa a quien le compro, en
     * las ventas a quien le vendio. El resto de la fila es igual, asi que se arma una sola vez.
     */
    columnas = (comoVendedor) => [
        {title: "ID", field: "id"},
        {
            title: comoVendedor ? "Comprador" : "Vendedor",
            field: comoVendedor ? "comprador.username" : "vendedor.username",
            mobileTitle: true,
            render: (row) => authService.formatUserName(comoVendedor ? row.comprador : row.vendedor)
        },
        {
            title: "Productos",
            mobile: false,
            // `cantidad` no existe en Venta: sale de items.length, asi que no se puede ordenar.
            sorting: false,
            render: (row) => (row.items ? row.items.length : 0)
        },
        {
            title: "Total",
            field: "total",
            render: (row) => (
                <NumberFormat
                    prefix={"$"}
                    value={row.total}
                    displayType={"text"}
                    thousandSeparator="."
                    decimalSeparator=","
                />
            )
        },
        {title: "Estado", field: "estado"},
        {
            title: "Fecha",
            field: "createdDate",
            render: (row) => <Moment date={row.createdDate} format="DD/MM/YYYY HH:mm"/>
        },
        {
            title: "",
            cellStyle: {textAlign: "center"},
            render: (row) => (
                <div className="table-button">
                    <Link to={"/comprador/compraDetail?id=" + row.id}>
                        <FontAwesomeIcon className={"button"} data-type={"complementary-smallest"}
                                         icon="fa-solid fa-eye"/>
                    </Link>
                </div>
            )
        }
    ];

    render() {
        const {usuario, show, handleClose} = this.props;

        const options = {
            search: false,
            sorting: true,
            filtering: false,
            selection: false,
            pageSize: 10,
            pageSizeOptions: [5, 10, 25, 50],
            overflowX: "auto",
            tableLayout: "auto"
        };

        const tableStyle = {
            tableLayout: "auto",
            width: "100%",
            maxWidth: "100%",
            borderRadius: "1rem",
            border: "1px solid #d2d2d2",
            boxShadow: "none",
            backgroundColor: "inherit",
            color: "inherit"
        };

        return (
            <Modal size="xl" show={show} onHide={handleClose} scrollable={true}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Movimientos de {authService.formatUserName(usuario)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs
                        id="movimientos-usuario"
                        activeKey={this.state.tipoKey}
                        onSelect={(k) => this.setState({tipoKey: k})}
                    >
                        <Tab eventKey="COMPRAS" title="Compras">
                            <div className="dashboard__content-main--tab">
                                <MiTabla
                                    title=""
                                    tableRef={tableRefCompras}
                                    columns={this.columnas(false)}
                                    options={options}
                                    style={tableStyle}
                                    data={(query) => this.buscarData(query, false)}
                                    detailPanel={(rowData) => <VentaDP rowData={rowData}/>}
                                    localization={traerPalabrasTabla("Compras")}
                                />
                            </div>
                        </Tab>

                        <Tab eventKey="VENTAS" title="Ventas">
                            <div className="dashboard__content-main--tab">
                                <MiTabla
                                    title=""
                                    tableRef={tableRefVentas}
                                    columns={this.columnas(true)}
                                    options={options}
                                    style={tableStyle}
                                    data={(query) => this.buscarData(query, true)}
                                    detailPanel={(rowData) => <VentaDP rowData={rowData}/>}
                                    localization={traerPalabrasTabla("Ventas")}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button" data-type="secondary" type="button" onClick={handleClose}>
                        Cerrar
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export {VentasUsuarioModal};
